import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import unprocessedFontCollection from './static-unprocessed-font-collection.json';
import { processFontCollection, deriveFontModelFromCSS, removeDiacritics, createFVSPropertyMap } from '@cargo/common/font-helpers';
import ContentEditable from '@cargo/ui-kit/content-editable/content-editable';
import { isServer } from "@cargo/common/helpers";
import loadFonts from '@cargo/font-loader';
import CopyIcon from "@cargo/common/icons/copy.svg";

import { Button } from "@cargo/ui-kit/button/button";
import { MessageContext } from "@cargo/ui-kit/message/message-controller";

const fontObserverMap = new Map();
let intersectionObserver;

const loadingFontFamilies = [];
const ipsums = ['Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur in egestas arcu. Interdum et malesuada fames ac ante ipsum primis in faucibus', 'Aenean dignissim lacinia ante in gravida. Pellentesque blandit lectus vel arcu maximus lacinia. Nullam nunc sapien, vehicula eget ante sed, rhoncus eleifend enim', 'Nam at purus ullamcorper massa malesuada accumsan. Pellentesque non dolor eros. Aliquam a ornare ante. Vivamus mattis eget quam ut varius', 'Nullam lobortis tempor congue. Phasellus eget iaculis nisl, Vestibulum quis velit vehicula, consequat magna id, vehicula lacus', 'Duis urna metus, efficitur eget porta et, imperdiet ut nulla. Nulla lobortis volutpat elit sed faucibus. Aliquam id mi auctor, porttitor erat accumsan, sagittis nisi', 'Curabitur condimentum hendrerit felis, id consectetur urna laoreet non. Nullam vitae ex in est sollicitudin luctus nec ac purus. Nullam tinibus eleifend purus sed pulvinar', 'Duis scelerisque sagittis mi quis semper. Cras fermentum convallis semper. Duis aliquam egestas augue ut pellentesque. Nam mi ipsum, tinibus a urna et, aliquam sodales eros', 'Cras et diam nunc. Etiam sed lorem laoreet, egestas mi tincidunt, faucibus justo. Nulla facilisi. Fusce tincidunt ipsum ut ante sagittis eleifend. Phasellus at ultricies nisi', 'Aliquam auctor bibendum nisi, blandit auctor dui pharetra sit amet. Maecenas at massa ultricies, feugiat elit vitae, interdum dui. Vivamus mattis eget quam ut varius', 'Nullam sit amet arcu nec justo auctor ultricies nec quis ipsum. Duis in dolor at leo ornare rutrum a vitae lorem. Proin eu viverra nulla', 'Vivamus in pellentesque est. Nam pellentesque lectus ipsum. Aenean porttitor, elit in ornare viverra, metus ex placerat justo, a faucibus lorem dui nec leo', 'Quisque aliquam sollicitudin elit et pellentesque. Suspendisse gravida porttitor magna sed gravida. Sed pharetra viverra purus', 'Proin imperdiet ac libero vitae euismod. Phasellus neque felis, rhoncus vulputate dui vel, congue gravida orci. Etiam bibendum lorem ultricies accumsan fermentum', 'Duis eu urna sapien. Phasellus placerat dolor in commodo consectetur. Nullam id laoreet velit, eu bibendum nisl. In at cursus metus', 'Cras consequat eu justo in scelerisque. Vestibulum dolor turpis, tincidunt id mattis a, faucibus sed velit. Vestibulum molestie, dui sit amet rutrum ultrices, orci enim convallis ante, vitae lacinia tellus', 'Sed ac consequat dui. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas sit amet semper orci. Nunc sollicitudin faucibus erat, ut molestie est tempor ac', 'Sed condimentum ornare velit quis dignissim. Quisque ipsum sapien, convallis ac est eu, lacinia pellentesque purus. Class aptent taciti sociosqu ad litora torquent per conubia nostra', 'Nam orci purus, consequat non lorem sit amet, sollicitudin vehicula tellus. Aliquam et feugiat est. Pellentesque lobortis ligula dignissim mauris porttitor, nec pretium arcu sodales', 'Pellentesque vehicula tempus odio posuere vehicula. Fusce sit amet tortor pellentesque, sagittis turpis et, varius eros. Praesent scelerisque felis tempus, volutpat neque eu, sodales dui', 'Praesent ac augue eu orci tincidunt porta vel ut purus Praesent ut blandit metus. Suspendisse sit amet ipsum congue. Aliquam ut ipsum eget felis commodo ullamcorper. ', 'Pellentesque sit amet sagittis urna. Fusce sollicitudin mauris sit amet mattis blandit. Pellentesque dignissim nec tellus rhoncus viverra. Vivamus mattis eget quam ut varius', 'Nunc tincidunt vestibulum urna ut ultrices. Fusce eu lacus velit. Suspendisse at libero venenatis, aliquet purus vitae, malesuada odio. lacus velit. Suspendisse at libero venenatis, aliquet purus vitae.', 'Vivamus tinibus nibh leo, id iaculis elit hendrerit vitae. Fusce aliquam nibh bibendum faucibus tristique. Cras aliquet, arcu et sagittis posuere, arcu lacus luctus ante, id pellentesque odio.', 'Eros vel sapien. Aenean sed metus eros. Fusce porta, lectus ut aliquam iaculis, massa massa consequat enim, ut volutpat orci nunc quis arcu. vitae lacinia tellus', 'Aliquam lacinia ligula sagittis, tempor nunc tinibus, sodales est. Nunc ullamcorper convallis nibh sit amet facilisis. Proin eget enim id felis tempus cursus. ', 'Duis dignissim dolor urna, quis scelerisque leo dapibus sed. Integer blandit convallis ante, vel convallis eros ullamcorper quis. Faucibus lorem dui nec leo', 'Cras condimentum magna nec urna pulvinar, nec tempor massa porta. Proin dapibus dolor gravida porttitor mattis. Phasellus molestie venenatis libero, in molestie odio suscipit', 'Quisque placerat tortor non lacus sollicitudin pellentesque. Maecenas eu scelerisque orci. Curabitur congue lacus odio, eget lobortis ipsum pellentesque ut', 'Proin viverra fringilla felis id tinibus. Pellentesque urna orci, consequat quis pharetra in, elementum quis magna. Cras sed nisl ac turpis molestie bibendum. Sed tinibus, enim quis tincidunt', 'Donec a viverra felis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Sed erat velit, mollis non sollicitudin a, fringilla id sem', 'Suspendisse condimentum tellus pulvinar mi hendrerit, eu vestibulum ligula tempor. Ut purus ligula, luctus sit amet tinibus vitae, pharetra vel arcu. Fusce feugiat hendrerit mauris', 'Praesent consectetur leo eget enim euismod hendrerit. Praesent tempus ut quam vitae ornare. Vivamus rhoncus, quam id fermentum ultricies, justo dolor auctor lectus, porta feugiat', 'Curabitur sodales tempor est, et tempor ante bibendum quis. Quisque molestie gravida cursus. Integer aliquet id augue non hendrerit. Etiam efficitur convallis euismod. Phasellus vel enim', 'Duis elit orci, iaculis a feugiat hendrerit, egestas id metus. Aenean bibendum dolor scelerisque vulputate euismod. Fusce ipsum felis, rhoncus eget lorem non, dapibus efficitur', 'Pellentesque metus elit, interdum eu nunc quis, pulvinar dignissim nisi. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Cras elementum facilisis ex', 'Pellentesque non ipsum quam. Pellentesque ornare ex in felis gravida consectetur. Cras cursus porta tellus a congue. Ut fringilla nulla eu rutrum commodo', 'Nullam convallis ipsum viverra ante placerat, ac tempor eros tempus. Pellentesque vestibulum blandit rutrum. Class aptent taciti sociosqu ad litora torquent per conubia nostra', 'Donec mollis nibh massa, id facilisis nunc eleifend non. In hac habitasse platea dictumst. Pellentesque ac blandit tortor, ac tempor sapien. Vestibulum quis neque pellentesque, sodales odio quis', 'Praesent scelerisque leo id lectus efficitur tristique. Vestibulum commodo interdum metus. Sed porta pulvinar arcu, non varius dolor. Lorem ipsum dolor sit amet, consectetur adipiscing elit', 'Nullam id nibh pellentesque, porta tortor eu, tincidunt justo. Donec nec nulla sit amet nulla vehicula rhoncus eu eget enim. Nunc sed ipsum eget dolor pellentesque semper. Nullam bibendum quam odio', 'Nullam eget tincidunt mauris. Nullam sagittis arcu eget mi gravida, eleifend tempor diam rutrum. Praesent rutrum, felis in gravida consequat, libero tellus pretium turpis', 'Fusce suscipit magna ac metus pellentesque ultricies. Donec sollicitudin orci in pulvinar hendrerit. Orci varius natoque penatibus et magnis dis parturient montes', 'Pellentesque ac quam sit amet orci ultricies rhoncus. Sed tempor non sapien non dapibus. Donec maximus maximus tempus. Maecenas interdum arcu in venenatis interdum', 'Vivamus et mi faucibus, condimentum ipsum luctus, rutrum tortor. Donec gravida vitae nunc ac porta. Sed rutrum magna non tinibus congue. Quisque condimentum risus et metus porttitor'];


if (!isServer) {

    intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            fontObserverMap.forEach((mapItem, key) => {
                if (mapItem.el === entry.target) {
                    if (entry.isIntersecting) {
                        let familyFromElement = entry.target.getAttribute('font-family');

                        let state = window.store.getState();
                        let fontsLoaded = state.homepageState.fontsLoaded;

                        if (!fontsLoaded.includes(familyFromElement) && !loadingFontFamilies.includes(familyFromElement)) {

                            let fontFamily = removeDiacritics(familyFromElement);
                            // let fontModel = deriveFontModelFromCSS(fontCollection, fontFamily );

                            // if( !fontModel ){
                            //     console.log("No font model data found for", familyFromElement )
                            //     return
                            // }

                            loadingFontFamilies.push(familyFromElement);

                            loadFonts({
                                context: window,
                                active: () => {
                                    let state = window.store.getState();
                                    let fontsLoaded = state.homepageState.fontsLoaded;
                                    let newFontsLoaded = [...fontsLoaded, familyFromElement];
                                    window.store.dispatch({
                                        type: 'UPDATE_HOMEPAGE_STATE',
                                        payload: { fontsLoaded: newFontsLoaded }
                                        // grid overlay
                                    });
                                },
                                families: [{
                                    provider: 'cargo',
                                    family: fontFamily
                                }]
                            }).then(() => {
                                let index = loadingFontFamilies.indexOf(familyFromElement);
                                if (index !== -1) {
                                    loadingFontFamilies.splice(index, 1);
                                }
                            });

                        } else {
                            // console.log(`Font for ${familyFromElement} already loaded`);
                        }

                        intersectionObserver.unobserve(entry.target);
                    }
                }
            });
        });
    }, {
        root: null,
        rootMargin: '0px 0px 2000px 0px',
        threshold: 0
    });
}

const createItalicVariants = (fonts) => {
    fonts.forEach(font => {
        const variants = font.variants;

        // Find the model italic variant to extract the slnt value
        const modelItalicVariant = variants.find(v => v.css_font_style === 'italic');
        let slntValue = null;

        if (modelItalicVariant && modelItalicVariant.writeable_fvs) {
            const fvsParts = modelItalicVariant.writeable_fvs.split(', ');
            fvsParts.forEach(part => {
                if (part.startsWith("'slnt'")) {
                    slntValue = part.split(' ')[1];
                }
            });
        }

        // Create a new array to store the updated variants with correct order
        const newVariants = [];

        variants.forEach((variant, index) => {
            if (variant.css_font_style === 'normal') {
                // Add the base (non-italic) variant
                newVariants.push(variant);

                const italicVariantName = `${variant.name} Italic`;
                const italicVariant = variants.find(v => v.name === italicVariantName);

                if (italicVariant) {
                    // If the italic variant already exists, move it just after the non-italic variant
                    newVariants.push(italicVariant);
                } else {
                    // Create a new italic variant if it doesn't exist
                    const newItalicVariant = { ...variant };

                    // Update the italic variant's properties
                    newItalicVariant.name = italicVariantName;
                    newItalicVariant.style = `${variant.style} Italic`;
                    newItalicVariant.css_font_style = 'italic';
                    newItalicVariant.reactStyle.fontStyle = 'italic';
                    newItalicVariant.vid += 99;
                    newItalicVariant.fvd = variant.fvd.replace('n', 'i');

                    if (newItalicVariant.writeable_fvs) {
                        newItalicVariant.writeable_fvs = newItalicVariant.writeable_fvs.replace("'slnt' 0", `'slnt' ${slntValue}`);
                    }

                    if (newItalicVariant.css_font_fvs) {
                        newItalicVariant.css_font_fvs = newItalicVariant.css_font_fvs.replace("'slnt' 0", `'slnt' ${slntValue}`);
                    }

                    if (newItalicVariant.reactStyle.fontVariationSettings) {
                        newItalicVariant.reactStyle.fontVariationSettings = newItalicVariant.reactStyle.fontVariationSettings.replace("'slnt' 0", `'slnt' ${slntValue}`);
                    }

                    // Insert the new italic variant just after the non-italic variant
                    newVariants.push(newItalicVariant);
                }
            } else if (!variants.some(v => v.name === variant.name.replace(' Italic', ''))) {
                // Add any italic variants that do not have a matching non-italic base
                newVariants.push(variant);
            }
        });

        // Replace the original variants array with the new one
        font.variants = newVariants;
    });

    return fonts;
}

export const FontsPreview = ({ isMobile }) => {

    const processedCollection = processFontCollection(unprocessedFontCollection); // Normal font processing
    const filteredCollection = processedCollection.filter(font => font.foundry && font.foundry.includes("Dinamo")); //Pull out Dinamo fonts
    const filteredCollectionWithItalics = createItalicVariants(filteredCollection); // Add italic variants to Dinamo fonts
    const dinamoVariantFlatMap = filteredCollectionWithItalics.flatMap(item => item.variants); // Flatten the Dinamo fonts for rendering
    const authenticated = useSelector(state => state.auth.authenticated);

    const [fontsInViewport, setFontsInViewport] = useState([]);
    const renderObserver = useRef(null);

    const renderOptions = {
        root: authenticated ? document.getElementById('fonts-page') : null,
        rootMargin: '1000px 0px 1000px 0px',
        threshold: 0
    }; 

    if(!isServer) {

        renderObserver.current = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    markForRender(entry.target.id);
                } else {
                    unmarkForRender(entry.target.id);
                }
            });
        }, renderOptions);

    }

    // Setup opacityObserver
    if (!authenticated && !isServer) {


    }

    useEffect(() => {
        // Cleanup observer on component unmount
        return () => {
            renderObserver.current?.disconnect();
        };
    }, []);

    const markForRender = (id) => {
        setFontsInViewport(prevState => [...prevState, id]);
    };

    // Function to unmark elements for rendering
    const unmarkForRender = (id) => {
        setFontsInViewport(prevState => prevState.filter(renderedId => renderedId !== id));
    };

    const rafOpacityIdRef = useRef(null);

    // Update style, function is called in syncWithRepaint to limit the number of updates and smooth things out.
    const updateStyles = useCallback((animations) => {
        animations.forEach(({ id, opacity }) => {
            const el = document.getElementById(id);
            el.style.opacity = opacity;
        });
    }, []);

    const syncOpacityWithRepaint = useCallback((animations) => {
        if (rafOpacityIdRef.current) {
            cancelAnimationFrame(rafOpacityIdRef.current);
        }
        rafOpacityIdRef.current = requestAnimationFrame(() => updateStyles(animations));
    }, [updateStyles]);

    useEffect(() => {

        const onScroll = () => {
            
                if( authenticated ){ return; }

                const windowHeight = window.innerHeight;

                const fontTesters = Array.from(document.querySelectorAll('.font-tester') );
                const fontVariants = Array.from(document.querySelectorAll('.font-grid li') );
                const elementsArray = [...fontTesters, ...fontVariants];
    
                const animationArray = [];

                elementsArray.forEach((el)=>{
                
        
                    const rect = el.getBoundingClientRect();
                    const elementId = el.getAttribute('id');

                    if( fontsInViewport.indexOf(elementId) === -1 && !el.classList.contains('font-tester') ){ 
                        return;
                    }

                    // follow this value around to gauge where we are in window
                    let midPoint = rect.top + rect.height*.5;
        
                    let keyframes = [
                        {opacity: 0}, // "100%"
                        {opacity: 0 }, // "95%"
                        {opacity: 0.4 }, // "90%"
                        {opacity: 0.6}, // "85%"
                        {opacity: 0.8 }, // "80%"
                        {opacity: 1 }, // "75%"
                        {opacity: 1 }, // "70%"
                        {opacity: 1 }, // "65%"
                        {opacity: 1 }, // "60%"
                        {opacity: 1 }, // "55%"
                        {opacity: 1 }, // "50%"
                        {opacity: 1 }, // "45%"
                        {opacity: 1 }, // "40%"
                        {opacity: 1 }, // "35%"
                        {opacity: 1 }, // "30%"
                        {opacity: 1 }, // "25%"
                        {opacity: 1 }, // "20%"
                        {opacity: 1 }, // "15%"
                        {opacity: 1 }, // "10%"
                        {opacity: 1 }, // "5%"
                        {opacity: 1 }, // "0%"
                    ]

                    // clamp midPoint to values where part of the element is inside the window
                    midPoint = Math.min(windowHeight + rect.height*.5, Math.max(rect.height *-.5, midPoint) );
        
                    const windowSections = keyframes.length -1;
        
                    // calculate the midpoint's position between these two values to figure out where in the animation timeline we are
                    const windowFrameMin = rect.height*-.5;
                    const windowFrameMax = windowHeight + rect.height*.5;
        
                    const sectionHeight = (windowFrameMax-windowFrameMin)/windowSections;
                    const positionInSection = ((midPoint -windowFrameMin) % sectionHeight)/sectionHeight;
                    const sectionIndex = Math.floor( Math.min(windowSections-1, (midPoint -windowFrameMin)/(windowFrameMax-windowFrameMin) * windowSections));
                    
                    const currentKeyFrames = {
                        first: keyframes[sectionIndex],
                        second: keyframes[sectionIndex+1] ? keyframes[sectionIndex+1] : keyframes[sectionIndex] ,
                    };
        
                    const opacity = currentKeyFrames.first.opacity * (1-positionInSection) + positionInSection *currentKeyFrames.second.opacity;

                    animationArray.push({
                        id:  elementId,
                        opacity: opacity,
                    })

                });
        
                syncOpacityWithRepaint(animationArray); 
        }

        window.addEventListener('scroll', onScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', onScroll);
        }

    }, [fontsInViewport]);


    const featuredTypeNetworkFonts = [
        'Adobe Arno Pro',
        'Big Caslon FB',
        'Dolly Pro',
        'Freight Big',
        'Freight Text',
        'Garage Gothic',
        'Guyot Headline',
        'Neue Haas Grotesk',
        'Interstate',
        'Marat',
        'Marat Sans',
        'Miller Text',
        'MVB Solitaire',
        'Nitti',
        'Nitti Grotesk',
        'Adobe Poetica',
        'Sabon',
        'Stanley',
        'Whitman',
        'Williams Caslon Text'];

    // const typeNetworkFonts = processedCollection.filter(font => font.foundry && font.foundry.includes("Type Network") );
    const typeNetworkFonts = processedCollection.filter(font => featuredTypeNetworkFonts.includes(font.family));
    const typeNetworkVariantFlatMap = typeNetworkFonts.flatMap(item => item.variants);

    const collectionDefaults = {
        "Arizona Sans": "'wght' 400, 'slnt' 0, 'SRFF' 0.75", //Arizona
        "Diatype": "'wght' 400, 'slnt' 0, 'MONO' 0",
        "Diatype Condensed": "'wght' 400, 'slnt' 0, 'wdth' 75",
        "Favorit": "'wght' 400, 'slnt' 0",
        "Gaisyr": null,
        "Gramercy": "'wght' 400, 'opsz' 12.01",
        "Gravity": "'wdth' 62, 'slnt' 0",
        "Monument Grotesk": "'wght' 400, 'slnt' 0, 'MONO' 0",
        "Marist": "'wght' 400",
        // start
        "Repro": "'wght' 400, 'slnt' 0",
        "ROM": "'wght' 400, 'slnt' 0",
        "ROM Condensed": "'wght' 400, 'slnt' 0",
        "Social": "'wght' 400, 'wdth' 100, 'slnt' 0",
        "Synt": "'wght' 400, 'slnt' 0",
        "Walter Neue": "'wght' 400, 'slnt' 0",
    }

    const featuredDinamoFonts = _.map(collectionDefaults, (defaults, keyName) => {
        let familyKeyName = defaults === null ? keyName : `${keyName} Variable`;
        let familyMatch = processedCollection.find(font => font.family === familyKeyName);
        familyMatch.printName = familyMatch.family.replace(' Sans', '');
        familyMatch.axisDefaults = defaults;
        return familyMatch
    });

    const getVariant = (variants) => {
        // First check for "style" equal to "regular" (case insensitive)
        let regularStyleVariant = variants.find(variant =>
            variant.style && variant.style.toLowerCase() === 'regular'
        );

        if (regularStyleVariant) {
            return regularStyleVariant;
        }

        // Failing that, check for "weight" equal to 400 (either as string or number)
        let weight400Variant = variants.find(variant =>
            variant.weight == 400
        );

        if (weight400Variant) {
            return weight400Variant;
        }

        // Failing that, check for "weight" equal to n4
        let n4WeightVariant = variants.find(variant =>
            variant.fvd = 'n4'
        );

        if (n4WeightVariant) {
            return n4WeightVariant;
        }

        // Failing that, check for "name" containing "regular"
        let regularNameVariant = variants.find(variant =>
            variant.name && variant.name.toLowerCase().includes('regular')
        );

        if (regularNameVariant) {
            return regularNameVariant;
        }

        // If none of the above conditions are met, return null or undefined
        return null;
    }

    // const fontSamplesHeight = featuredDinamoFonts.length * 150;
    // style={{ minHeight: `${fontSamplesHeight}px` }}
    // console.log("fontsInViewport", fontsInViewport)
    return (
        <>
            <div className="font-samples">
                <div className="font-testers">
                    {featuredDinamoFonts.map((font, index) => {
                        const variant = getVariant(font.variants);
                        if (!variant) {
                            return null;
                        }
                        const className = font.family.replace(/ /g, '-').toLowerCase();
                        const defaults = createFVSPropertyMap(font.axisDefaults);
                        return (
                            <FontTester
                                key={font.family + variant.vid}
                                font={font}
                                variant={variant}
                                className={className}
                                defaults={defaults}
                                authenticated={authenticated}
                                isMobile={isMobile}
                            />
                        );
                    })}
                </div>
            </div>
            <FontSizeSlider />
            <div className="font-grid">
                <ul>
                    {dinamoVariantFlatMap.map((variant, index) => {

                        const className = variant.family.replace(/ /g, '-').toLowerCase() + variant.vid;

                        return (
                            <FontVariantRow
                                key={variant.family + variant.vid}
                                fontVariant={variant}
                                className={className}
                                fontsInViewport={fontsInViewport}
                                renderObserver={renderObserver}
                            />
                        );
                    })}
                </ul>
            </div>
            <br /><br /><br /><br />
        </>
    );
};

const FontGridHeader = ({ provider, linkText, providerLink, imageName }) => (
    <div className={`font-grid`}>
        <div className="title">{provider}</div>
        <a className="provider-link" target="_blank" href={providerLink}>
            <img src={`${PUBLIC_URL}/images/${imageName}`} alt={`${provider} Logo`} />
            <span>{linkText}</span>
        </a>
    </div>
);

const FontTester = ({ font, className, defaults, authenticated, isMobile }) => {

    const ref = useRef(null);
    const editableRef = useRef(null);

    const fontsLoaded = useSelector(state => state.homepageState.fontsLoaded);

    const [displayLoadedFont, setDisplayLoadedFont] = useState(fontsLoaded.indexOf(font.family) !== -1);

    // store ipsum in state so we don't randomize it every render
    const [randomIpsum] = useState(ipsums[Math.floor(Math.random() * ipsums.length)]);

    useEffect(() => {

        const el = ref.current;
        if (el && intersectionObserver) {
            fontObserverMap.set(el, { el, component: null });
            intersectionObserver.observe(el);
        }

        return () => {
            if (el && intersectionObserver) {
                intersectionObserver.unobserve(el);
                fontObserverMap.delete(el);
            }
        };
    }, []);


    useEffect(() => {

        if (
            // we have loaded the first fonts
            fontsLoaded.length > 0 
            // and we're not in the middle of loading more fonts
            && loadingFontFamilies.length === 0
            // and this family is ready to be shown
            && fontsLoaded.indexOf(font.family) !== -1
        ) {
            setDisplayLoadedFont(true)
        }
    }, [fontsLoaded])

    const style = { opacity: displayLoadedFont ? 1 : 0 };
    const idForOpacity = font.cssName.toLowerCase().replace(/\s+/g, '');

    return (
        <div
            ref={ref}
            className={`font-tester ${className}`}
            style={style}
            id={idForOpacity}
            fontFamily={font.family}
        >
            <AxisSliderHandler 
                font={font} 
                className={className} 
                defaults={defaults} 
                editableRef={editableRef}
                authenticated={authenticated}
                isMobile={isMobile}
            />

            <div className="editable" ref={editableRef}>
                <ContentEditable
                    initialValue={`${font.printName} — ${randomIpsum}`}
                    tag="span"
                />
            </div>
        </div>
    );
};

const AxisSliderHandler = ({ font, className, defaults, editableRef, authenticated, isMobile }) => {

    // Manually create size axis.
    const sizeAxis = { css_fvs: "fontSize", id: 0, max: 450, min: 48, step: 0.1, title: "Size" };
    // Font size related state.
    const defaultFontSize = 50 * 1.4;
    const [fontSize, setFontSize] = useState(defaultFontSize);

    // State for axis values. Initialize with default values or empty if no defaults.
    const [axisValues, setAxisValues] = useState(
        font.axes ? font.axes.reduce((acc, axis) => {
            acc[axis.css_fvs] = defaults[axis.css_fvs];
            return acc;
        }, {}) : {}
    );

    const fvsString = () => Object.entries(axisValues).map(([axis, value]) => {
        if (axis === 'slnt') {
            value = -value;
        }
        return `'${axis}' ${value}`;
    }).join(', ');

    // Refs to track style tag and requestAnimationFrame id.
    // const styleRef = useRef();
    const rafIdRef = useRef(null);

    // Update style, function is called in syncWithRepaint to limit the number of updates and smooth things out.
    const updateStyles = useCallback(() => {
        // if (styleRef.current) {

            if( editableRef.current ){
                const child = editableRef.current.firstElementChild;
                child.style.fontFamily = font.family;
                child.style.fontSize = `calc(var(--scale) * ${fontSize}px)`;
                if (font.axes) {
                    child.style.fontVariationSettings = fvsString();
                }
                child.style.fontWeight = axisValues['wght'] || 400;
            }

            // styleRef.current.textContent = `
            //     .${className} span[contenteditable="true"] {
            //         font-family: '${font.family}';
            //         ${font.axes ? `font-variation-settings: ${fvsString()};` : ''}
            //         ${axisValues['wght'] ? `font-weight: ${axisValues['wght']};` : 'font-weight: 400;'}
            //         font-size: calc(var(--scale) * ${fontSize}px) !important;
            //     }
            // `;
        // }
    }, [axisValues, className, font.family, fontSize]);

    const syncWithRepaint = useCallback(() => {
        if (rafIdRef.current) {
            cancelAnimationFrame(rafIdRef.current);
        }
        rafIdRef.current = requestAnimationFrame(updateStyles);
    }, [updateStyles]);

    const handleSliderChange = useCallback((css_fvs, value) => {
        if (css_fvs === 'fontSize') {
            setFontSize(value);
        } else {
            setAxisValues(prevValues => ({
                ...prevValues,
                [css_fvs]: value
            }));
        }
    }, []);

    useEffect(() => {
        syncWithRepaint();
        return () => {
            if (rafIdRef.current) {
                cancelAnimationFrame(rafIdRef.current);
            }
        };
    }, [axisValues, fontSize, syncWithRepaint]);

    if( isMobile ){
        return <br/>
    }

    return (
        <>
            <div className="sliders">
                <MemoizedAxisSlider
                    axis={sizeAxis}
                    value={fontSize}
                    onChange={handleSliderChange}
                />
                {font.axes && font.axes.map((axis, index) => (
                    <MemoizedAxisSlider
                        key={index}
                        axis={axis}
                        value={axisValues[axis.css_fvs]}
                        onChange={handleSliderChange}
                    />
                ))}
            </div>
            {/* <style ref={styleRef}></style> */}
            {authenticated &&
                <MessageContext.Consumer>{(Message) => (
                    <Button
                        className={`copy`}
                        icon={<CopyIcon />}
                        onClick={(e) => {

                            // Rem is n * the root element's font size. So if the <html> font size is 12px, and your font is 10 rem, it's size is 120px;
                            const rootFontSize = 16 * (parseFloat(document.documentElement.style.getPropertyValue('--base-size')) / 100);
                            const elementFontSize = parseFloat(fontSize);
                            const fontSizeInRem = Math.round(((elementFontSize / rootFontSize) +  Number.EPSILON) * 100) / 100 + 'rem';

                            const fontStyle = {
                                'font-family': font.family,
                                'font-size': fontSizeInRem,
                                'font-weight': axisValues['wght'] ? axisValues['wght'] : '400'
                            }

                            if(font.axes) {
                                fontStyle['font-variation-settings'] = fvsString();
                            }

                            // write shortcode to clipboard
                            navigator.clipboard.writeText(`cargo:?inject-font&name=${font.printName}&styles=${btoa(JSON.stringify(fontStyle))}`);

                            // show message
                            Message.showMessage({
                                messageText: "Copied.<br /><br />You can paste this into any site (⌘V)",
                                duration: 2000,
                                preventClickout: false,
                                className: 'tall',
                            });

                            e.preventDefault();
                        }}
                    />
                )}</MessageContext.Consumer>
            }
            <br />
        </>
    );
};

const MemoizedAxisSlider = React.memo(({ axis, value, onChange }) => {

    const isDraggingRef = useRef(false);

    const handleChange = useCallback((e) => {
        onChange(axis.css_fvs, e.target.value);
    }, [axis.css_fvs, onChange]);

    const max = axis.css_fvs === 'slnt' ? Math.abs(axis.min) : axis.max;
    const min = axis.css_fvs === 'slnt' ? 0 : axis.min;

    useEffect(() => {
        // Cleanup event listener on unmount...
        return () => {
            if ( isDraggingRef.current ) {
                if( document.body.style.cursor ){
                    document.body.style.cursor = '';
                }
                document.removeEventListener('pointerup', handlePointerUp);
                isDraggingRef.current = false;
            }
        };
    }, []);

    const handlePointerUp = useCallback(() => {
        // Remove the inline cursor style
        document.body.style.cursor = ''; 
        document.removeEventListener('pointerup', handlePointerUp);
        isDraggingRef.current = false;
    }, []);

    const handlePointerDown = useCallback(() => {
        // Set the cursor to pointer — removed when we're done draggging.
        document.body.style.cursor = 'pointer';
        isDraggingRef.current = true;
        // Add the pointerup event listener to the document
        document.addEventListener('pointerup', handlePointerUp, {once: true});
    }, [handlePointerUp]);
    

    return (
        <div className="axis-slider">
            {axis?.title ? (<span>{axis.title}</span>) : null}
            <input
                className="variable-font-range"
                type="range"
                name={"axis-" + axis.css_fvs}
                min={min}
                max={max}
                step={axis.step}
                value={value}
                onChange={handleChange}
                onPointerDown={handlePointerDown}
            />
        </div>
    );
});


const FontVariantRow = ({ fontVariant, className, renderObserver, fontsInViewport }) => {

    const ref = useRef(null);
    const fontsLoaded = useSelector(state => state.homepageState.fontsLoaded);
    const [displayLoadedFont, setDisplayLoadedFont] = useState(fontsLoaded.indexOf(fontVariant.family) !== -1);

    // store ipsum in state so we don't randomize it every render
    const [randomIpsum] = useState(ipsums[Math.floor(Math.random() * ipsums.length)]);

    useEffect(() => {
        const el = ref.current;
        if (el && intersectionObserver) {
            fontObserverMap.set(el, { el, component: null });
            intersectionObserver.observe(el);
        }

        if (el && renderObserver.current) {
            renderObserver.current.observe(el);
        }

        return () => {
            if (el && intersectionObserver) {
                intersectionObserver.unobserve(el);
                fontObserverMap.delete(el);
            }
        };
    }, []);

    useEffect(() => {
        if (fontsLoaded.indexOf(fontVariant.family) !== -1) {
            setDisplayLoadedFont(true)
        }
    }, [fontsLoaded])

    const fvsString = fontVariant?.css_font_fvs ? `font-variation-settings: ${fontVariant?.css_font_fvs};` : '';
    const fontName = fontVariant?.name?.match(' Variable') ? fontVariant.name.replace(' Variable', '') : fontVariant?.name;
    const fontKey = `${fontVariant.name.toLowerCase()}-${fontVariant.vid.toString()}`.replace(/\s+/g, '');
    const shouldRenderFont = fontsInViewport.includes( fontKey );
    const isItalic = fontVariant?.css_font_style === 'italic' || fontVariant?.reactStyle === 'italic';

    const styleTag = `.${className} span {
        font-family: '${fontVariant.family}';
        font-weight: ${fontVariant.weight};
        ${isItalic ? 'font-style: italic;' : ''}
        ${fvsString}
    }`.trim();

    return (
        <li
            ref={ref}
            className={`font-tester ${className}`}
            fontFamily={fontVariant.family}
            id={fontKey}
        >
            <div className="editable">
                <ContentEditable
                    initialValue={`${fontName} — ${randomIpsum}`}
                    tag="span"
                    style={shouldRenderFont ? null : { 'fontFamily': 'none', 'color': 'transparent' }}
                />
                <style>{styleTag}</style>
            </div>
        </li>
    );

    //    {shouldRenderFont && displayLoadedFont ? (<>
    //         <ContentEditable
    //             initialValue={`${fontName} — ${randomIpsum}`}
    //             tag="span"
    //         />
    //     </>) : <div></div>} 
};

const FontSizeSlider = () => {
    // THIS IS FOR THE SMALL FONTS
    // Featured fonts at the top of the list use their own memoizedAxisSlider
    const axis = {
        css_fvs: "size",
        id: 0,
        max: 135,
        min: 18,
        step: 0.1,
        title: null,
    };

    const sliderDefault = 48;

    const [axisValues, setAxisValues] = useState({ [axis.css_fvs]: sliderDefault });

    const handleSliderChange = (css_fvs, value) => {
        setAxisValues(prevValues => ({
            ...prevValues,
            [css_fvs]: value
        }));
    };

    const fullRowSize = axisValues[axis.css_fvs] + (axisValues[axis.css_fvs] * 0.5);

    return (
        <div className={`font-size-slider`}>
            {/* <MemoizedAxisSlider
                axis={axis}
                value={axisValues[axis.css_fvs]}
                onChange={handleSliderChange}
            /> */}
            <style>
                {`#fonts-page .font-grid ul li {
                    font-size: calc(var(--scale) * ${axisValues[axis.css_fvs]}px);
                }`}
                {`#fonts-page .font-grid ul li span, #fonts-page .font-grid ul li span {
                    min-height: calc(var(--scale) * ${axisValues[axis.css_fvs]}px);
                    height: calc(var(--scale) * ${axisValues[axis.css_fvs]}px);
                    max-height: calc(var(--scale) * ${axisValues[axis.css_fvs]}px);
                }
                #fonts-page .font-grid ul li {
                    min-height: calc(var(--scale) * ${fullRowSize}px);
                    height: calc(var(--scale) * ${fullRowSize}px);
                    max-height: calc(var(--scale) * ${fullRowSize}px);
                }
                `}
            </style>
        </div>
    );
};
